export default "__VITE_ASSET__DBM$o0dq__"